import { atom } from "jotai";

export const userAvatarVersionAtom = atom<number>(0);
